import { render } from "./ShoppingCategoryListItem.vue?vue&type=template&id=18fec7a7&scoped=true&ts=true"
import script from "./ShoppingCategoryListItem.vue?vue&type=script&lang=ts"
export * from "./ShoppingCategoryListItem.vue?vue&type=script&lang=ts"

import "./ShoppingCategoryListItem.vue?vue&type=style&index=0&id=18fec7a7&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fec7a7"]])

export default __exports__